import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


const DoEditor = (props) => {
    const {
        name,
        id = name,
        label = "",
        placeholder,
        markReq,
        field = {},
        fieldState = {},
        errors = {},
        disabled = false
    } = props;

    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        if (field.onChange) {
            field.onChange(data);
        }
        if (props.ckEditorData) {
            props.setCkEditorData(data);
        }
        if (props.getEditorText) {
            props.getEditorText(data);
        }
    };

    return (
        <div className="flex flex-column">
            <div className="flex align-center mb-1">
                {label && (
                    <label htmlFor={id} className="text-capitalize">
                        {label}
                    </label>
                )}

            </div>

            <CKEditor
                config={{
                    placeholder: placeholder || "",
                }}
                editor={ClassicEditor}
                data={field?.value || ""}
                onReady={(editor) => {
                    if (disabled) {
                        editor.enableReadOnlyMode("react-wrapper");
                    } else {
                        editor.disableReadOnlyMode("react-wrapper");
                    }
                }}
                onChange={handleEditorChange}
                disabled={disabled}
            />

            {fieldState?.invalid && errors[name]?.message && (
                <small className="text-danger">{errors[name].message}</small>
            )}
        </div>
    );
};

export default DoEditor;